var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Chartist',{ref:"chart",attrs:{"id":"donutPareto","data":_vm.chartData,"event-handlers":_vm.eventHandlers,"options":_vm.chartOptions,"ratio":"ct-square","type":"Pie"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }